import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { V2ButtonComponent } from '@coin/shared/core/ui-storybook';
import { TranslationViewerService } from '../../data/translation-viewer.service';

/**
 * Prominent, always-visible banner shown while the translation key viewer is active.
 * Gives the user a one-click way to disable it without re-opening the user menu.
 * Text is intentionally hardcoded (not translated) so it stays readable while the
 * viewer replaces every translation value with its key.
 */
@Component({
  selector: 'coin-translation-viewer-banner',
  standalone: true,
  imports: [MatIconModule, V2ButtonComponent],
  templateUrl: './translation-viewer-banner.component.html',
  styleUrls: ['./translation-viewer-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TranslationViewerBannerComponent {
  public readonly translationViewer = inject(TranslationViewerService);
}
